import React from 'react';
import config from 'config';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { replaceWithQuery as replace, pushWithQuery as push } from 'utils/routing';
import { getQuerySearch } from 'reselects';
import { defaultTableRowRenderer } from 'react-virtualized';
import { injectIntl } from 'react-intl';
import LoadingSection from 'components/LoadingSection';
import { fetchNextVehicles, searchVehicles } from 'redux/modules/vehicle-section/effects';
import {
  getAllVehicles,
  getTotalVehicleCount,
  getIsVehiclesFetching,
  getIsVehiclesFetchingNext,
  getNextVehiclesLink,
} from 'redux/modules/vehicle-section/selectors';
import { withRouter } from 'react-router-dom';
import VehicleList from './component';

const actionCreators = {
  fetchNextVehicles,
  searchVehicles,
};

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state, ownProps) => {
    return {
      vehicles: getAllVehicles(state),
      totalVehicles: getTotalVehicleCount(state),
      fetching: getIsVehiclesFetching(state),
      fetchingNext: getIsVehiclesFetchingNext(state),
      hasNextPage: getNextVehiclesLink(state),
      query: getQuerySearch(ownProps),
    };
  }, actionCreators),
  withHandlers({
    handleRowClick:
      ({ query }) =>
      ({ rowData }) => {
        const { id } = rowData;
        push({ pathname: `${config.BASE_ROUTE}vehicle/${id}`, query });
      },
    handleResetFilters:
      ({ url, searchVehicles }) =>
      () => {
        replace(url);
        searchVehicles();
      },
    handleLoadMoreVehicles:
      ({ fetchNextVehicles }) =>
      () => {
        fetchNextVehicles();
      },
    showCallStatusModelHandler:
      ({ showModal }) =>
      (id) => {
        showModal(id);
      },
    handleCarrierClick: () => (id) => (e) => {
      e.stopPropagation();
      push({ pathname: `${config.BASE_ROUTE}carrier/${id}` });
    },
    handleGetRow:
      ({ vehicles }) =>
      ({ index }) => {
        return vehicles[index];
      },
    handleIsRowLoaded:
      ({ vehicles, fetchingNext, hasNextPage }) =>
      ({ index }) => {
        return index < vehicles.length - 1 || fetchingNext || !hasNextPage;
      },
  }),
  withHandlers({
    handleRowRendering:
      ({ handleIsRowLoaded }) =>
      ({ index, key, className, rowData, style, ...props }) => {
        if (!rowData) return;
        if (handleIsRowLoaded({ index })) {
          return defaultTableRowRenderer({
            index,
            key,
            style,
            className,
            rowData,
            ...props,
          });
        }
        return (
          <div style={style} {...props}>
            <LoadingSection />
          </div>
        );
      },
  })
);

export default enhance(VehicleList);
